/** Same-browser tab coordination (in addition to server WebSocket `boards:updated`). */
const CHANNEL = "canvas-board-list-v1";

export function notifyBoardListChanged(): void {
  if (typeof BroadcastChannel === "undefined") return;
  try {
    const bc = new BroadcastChannel(CHANNEL);
    bc.postMessage(0);
    bc.close();
  } catch {
    /* private mode, etc. */
  }
}

export function subscribeBoardListChanged(handler: () => void): () => void {
  if (typeof BroadcastChannel === "undefined") return () => {};
  try {
    const bc = new BroadcastChannel(CHANNEL);
    bc.onmessage = () => handler();
    return () => {
      bc.onmessage = null;
      bc.close();
    };
  } catch {
    return () => {};
  }
}
